var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"menuHoverSound",rawName:"v-menuHoverSound"},{name:"menuClickSound",rawName:"v-menuClickSound"}],staticClass:"Button",class:{
    large: _vm.size === 'large',
    normal: _vm.size === 'normal',
    small: _vm.size === 'small',
    ghost: _vm.styleName === 'ghost',
    darkghost: _vm.styleName === 'darkghost',
    primary: _vm.styleName === 'primary',
    common: _vm.styleName === 'common'
  },on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }